import { render, staticRenderFns } from "./ControlGrid.vue?vue&type=template&id=ffc6d868&scoped=true&"
import script from "./ControlGrid.vue?vue&type=script&lang=js&"
export * from "./ControlGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc6d868",
  null
  
)

export default component.exports